// Единая точка решения: слать ли события в GlitchTip.
//
// DSN захардкожен как fallback (в прод-окружении SENTRY_DSN не задаётся),
// поэтому без явного гейта локальная разработка шлёт ошибки в продовый
// проект — в GlitchTip видны события с environment=development и
// server_name=<ноутбук>. Такой шум искажает счётчики и мешает разбирать
// реальные проблемы пользователей, поэтому по умолчанию события уходят
// только из production.
//
// Форс для локальной отладки самой интеграции:
//   SENTRY_FORCE_ENABLE=true              — сервер
//   NEXT_PUBLIC_SENTRY_FORCE_ENABLE=true  — клиент

const SENTRY_ENVIRONMENT =
  process.env.SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development";

const isForceEnabled =
  process.env.SENTRY_FORCE_ENABLE === "true" ||
  process.env.NEXT_PUBLIC_SENTRY_FORCE_ENABLE === "true";

const isSentryEnabled = SENTRY_ENVIRONMENT === "production" || isForceEnabled;

module.exports = {
  SENTRY_ENVIRONMENT,
  isSentryEnabled,
};
